export * from 'server/models/VesselServiceOverrideResponse';


// WEBPACK FOOTER //
// ./data/models/VesselServiceOverrideResponse.ts